import * as AuthActions from '../../auth/actions/auth.actions';
import * as SearchActions from '../actions/search.actions';

// App State
export interface State {
  statements: Array<any> | null;
  participants: Array<any> | null;
  rt_max_number: number[] | null;
}

// Initial State
export const initialState: State = {
  statements: null,
  participants: null,
  rt_max_number: null
};

// Export Reducer
export function reducer(state = initialState, action: SearchActions.Actions | AuthActions.LogoutSuccess): State {
  switch (action.type) {

    // Search for participant or statement success
    case SearchActions.SEARCH_FOR_PARTICIPANT_STATEMENT_SUCCESS:
      const participants: any = action.payload.participants;

      let rt_max_number = null;
      if (participants.length > 0 && participants[0].activities.ratings && participants[0].activities.ratings.length > 0) {
        rt_max_number = Array(participants[0].activities.ratings.length).fill(1).map((x, i) => i + 1);
      }

      return {
        ...state,
        statements: action.payload.statements,
        participants: action.payload.participants,
        rt_max_number
      };

    // Reset results
    case SearchActions.RESET_SEARCH_RESULTS:
      return initialState;

    // User Logout
    case AuthActions.LOGOUT_SUCCESS:
      return initialState;

    // Default
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/app/core/reducers/search.reducer.ts